import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { StageMergeData } from './stage.merge.data';
import { StageItemMergeData } from './stage.items.merge.data';

@MergeSchema({
    entity: ActivityEntityName.WorkOrder,
    name: 'StageIncludeItemsMergeDataSchema',
})
export class StageIncludeItemsMergeData extends StageMergeData {
    @MergeField({
        arraySchemaName: 'StageItemsMergeSchema'
    })
    items: StageItemMergeData[] = [];
}

export const StageIncludeItemsMergeDataSchema = getSchema(StageIncludeItemsMergeData)